import { SECTION_NAMES } from '@repo/common';
import { REBATE_CAMPAIGN_TYPE } from '../../types/campaign.types';
import type { ICampaignConfig } from '../campaignConfig.types';

const REBATES_API_URLS = {
  PREFIX: 'rebateservice/api/game-client/rebates/',
  GET_REBATE: 'get-all',
  JOIN_REBATE: 'join',
};

const { PREFIX, GET_REBATE, JOIN_REBATE } = REBATES_API_URLS;

export const rebateConfig: ICampaignConfig = {
  type: REBATE_CAMPAIGN_TYPE,
  displayName: 'Rebate',
  sectionName: SECTION_NAMES.REBATE,
  hostSettingsKey: 'rebateHost',
  ssiKey: 'rebateHost',
  envVarKey: 'REBATE_HOST',
  mainFetch: {
    urlTemplate: `\${host}${PREFIX}${GET_REBATE}`,
    timing: {
      staleTime: 5 * 60 * 1000,
      refetchInterval: 60 * 1000,
      refetchOnWindowFocus: true,
    },
    retry: {
      maxRetries: 2,
      retryDelayBase: 1000,
      maxRetryDelay: 30000,
    },
    queryKeySegments: ['rebate', 'list'],
  },
  subFetches: {
    join: {
      name: 'join',
      urlTemplate: `\${host}${PREFIX}${JOIN_REBATE}`,
      method: 'POST',
      timing: {
        staleTime: 0,
        refetchInterval: false,
        refetchOnWindowFocus: false,
      },
      retry: {
        maxRetries: 1,
        retryDelayBase: 1000,
        maxRetryDelay: 5000,
      },
      queryKeySegments: ['rebate', 'join'],
      buildJoinInRequestData: ({ sessionInfo, url, data }) => {
        const queryString = new URLSearchParams(sessionInfo as any).toString();
        const fullUrl = `${url}?${queryString}`;
        const body = data;

        return {
          fullUrl,
          requestBody: body,
        };
      },
    },
  },
  mutations: {},
};
